import React from 'react';
import PropTypes from 'prop-types';
import { track } from "../../api";
import TrackingContainer from "../TrackingContainer";
import { WindowFocusContext } from "../WindowFocus";
import DOM from "../../utils/DOM";
import Error, { ERROR_CODES } from "../Error";

const httpStatusToErrorCodeMap = {
  404: ERROR_CODES.INVALID_LINK,
  400: ERROR_CODES.BOOKING_NOT_FOUND,
}

const bookingIsCancelled = (bookingStatus) => {
  return (bookingStatus === "driver-cancelled" || bookingStatus === "customer-cancelled" || bookingStatus === "system-cancelled");
}

const wasBookingNotAssignedADriver = (bookingStatus) => {
  return (bookingStatus === "driver-not-found"); 
}

const wasBookingCompleted = (bookingStatus) => {
  return (bookingStatus === "completed"); 
}

const isGoSendBooking = (serviceType) => {
  return (serviceType === "go-kilat-new");
}

const isGoSendPartnerBooking = (customerType, serviceType) => {
  return (customerType === "partner") && (serviceType === "go-kilat-new" || serviceType === "sameday-kilat" || serviceType === "instant-mpmd" || serviceType === "go-send-instant-2w");
}

export default class PolledTrackingContainer extends React.Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    interval: PropTypes.number.isRequired,
  };

  state = {
    data: null,
    errorCode: null,
  };

  static contextType = WindowFocusContext;

  pollAfterInterval() {
    this.timeoutId = setTimeout(() => this.poll(), this.props.interval);
  }

  setStateForErrorCode(code) {
    this.setState({
      errorCode: code,
      data: null,
    });
  }

  windowHasFocus() {
    return this.context;
  }

  async poll() {
    if (!this.windowHasFocus()) {
      this.pollAfterInterval()
      return;
    }

    if (!DOM.hasInternet()) {
      this.setStateForErrorCode(ERROR_CODES.NO_INTERNET);
      this.pollAfterInterval();
      return;
    }

    try {
      const data = await track(this.props.token);

      if (bookingIsCancelled(data.status)) {
        let errorCode = ERROR_CODES.BOOKING_CANCELLED;
        
        if(isGoSendPartnerBooking(data.customerType || "", data.serviceType)) {
          if(data.cancelSource === 'dispatch') {
            errorCode = ERROR_CODES.GO_SEND_PARTNER_DISPATCH_CANCELLED
          } else {
            errorCode = ERROR_CODES.GO_SEND_PARTNER_BOOKING_CANCELLED
          }
        } else if(isGoSendBooking(data.serviceType)) {
          errorCode = ERROR_CODES.GO_SEND_BOOKING_CANCELLED
        }
        
        this.setStateForErrorCode(errorCode);
        return;
      }

      if(wasBookingNotAssignedADriver(data.status)) {
        const errorCode = isGoSendPartnerBooking(data.customerType || "", data.serviceType) ? ERROR_CODES.GO_SEND_PARTNER_DRIVER_NOT_FOUND : ERROR_CODES.DRIVER_NOT_FOUND;

        this.setStateForErrorCode(errorCode);
        return;
      }

      this.setState({data, errorCode: null});

      if (!wasBookingCompleted(data.status)) {
        this.pollAfterInterval();
        return;
      }
    } catch(err) {
      const errorCode = httpStatusToErrorCodeMap[err.status];
      if (errorCode) {
        this.setStateForErrorCode(errorCode);
        return;
      }

      this.setStateForErrorCode(ERROR_CODES.DEFAULT_ERROR);
      this.pollAfterInterval();
      return;
    }
  };

  componentDidMount() {
    this.poll();
  }

  componentWillUnmount() {
    clearInterval(this.timeoutId);
  }

  render() {
    const {errorCode, data} = this.state;
    return errorCode
      ? <Error code={errorCode}/>
      : data
      ? <TrackingContainer {...data} token={this.props.token}/>
      : null;
  }
}
